import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectAccountsComponent } from './select-accounts.component';
import { SystemIconModule } from '@app/transactions/components/transaction-form/system-icon/system-icon.module';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { SkeletonModule } from '@app/core/components/skeleton/skeleton.module';

@NgModule({
    declarations: [SelectAccountsComponent],
    exports: [SelectAccountsComponent],
    imports: [
        CommonModule,
        SystemIconModule,
        ContentLoaderModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        MatSelectModule,
        SkeletonModule
    ]
})
export class SelectAccountsModule {}
